import React from 'react';
import PropTypes from 'prop-types';

import './Title.css';

class Title extends React.PureComponent {

    render() {
        return (
            <div className="panel panel-default parent-title" style={{
                marginTop: 20,
                marginBottom: 0
            }}>
                <div 
                    className="panel-body" 
                    align="center"
                    style={{
                        padding: 10,
                        fontWeight: 'bold',
                        color: 'white',
                        backgroundColor: '#159897'
                    }}
                    >{this.props.text}</div>
            </div>
        )
    }
}

Title.propTypes = {
    text: PropTypes.string.isRequired
}

export default Title;